import { VTextField } from 'vuetify/lib'
import { defaultFun } from '../utils'
import { NUMBER_FIELD } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name: NUMBER_FIELD,
    mixins: [ commonMixins ],
    render(h) {
        const {
             // eslint-disable-next-line 
             slots,scopedSlots,
             key,
             d_digits = Infinity,
             blur = defaultFun,
             change = defaultFun,
             click = defaultFun,
             focus = defaultFun,
             input = defaultFun,
             keydown = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             mousewheel,
             'click:append':clickAppend = defaultFun,
             ...params 
            } = this.field
        params.type = 'number'
        return h(VTextField, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            ref:'VTextField',
            props: {
                ...params,
                value: this.my_value && this.my_value[key] 
            },
            on: {
                blur,
                change,
                click,
                focus,
                'click:append':(...o) => clickAppend(...o),
                input:(data) => {
                    data = data || ''
                    const len = data.length
                    const index = data.indexOf('.')
                    const _d_digits = len - index - 1
                    if (index !== -1 && _d_digits > d_digits) {
                        data = data.slice(0, index + d_digits + 1)
                    }
                    this.my_value[key] = ['', null, undefined].includes(data) ? null : Number(data)
                    input(this.my_value)
                    if (index !== -1 && _d_digits > d_digits) { // hack
                     this.$refs.VTextField.lazyValue = this.my_value[key]
                    }
                },
                // keydown,
                mousedown,
                mouseup,
                keydown,
                mousewheel: (evt, ...other) => {
                    if (mousewheel) {
                        mousewheel(evt, ...other)
                        return 
                    }
                    evt = evt || window.event;  
                    if (evt.preventDefault) {  
                    // Firefox  
                      evt.preventDefault();  
                      evt.stopPropagation();  
                    } else {  
                      // IE  
                      evt.cancelBubble = true;  
                      evt.returnValue = false;  
                  }  
                  return false;  
            
                }
            }
        })
    
    }
}